import IcomoonReact from 'icomoon-react';

import iconSet from '../../../assets/selection.json';

type ProductTypeIconProps = {
  type: 'Electricity' | 'Gas' | 'Renewables';
};

const icons = {
  Electricity: 'electricity',
  Gas: 'gas-02',
  Renewables: 'renewables',
};

export const ProductTypeIcon = ({ type }: ProductTypeIconProps) =>
  type ? <IcomoonReact className='energyTypeIcon' iconSet={iconSet} size={20} icon={icons[type]} /> : null;
